import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, Group, LoadingOverlay } from '@mantine/core'
import { showNotification } from '@mantine/notifications'
import { MainLayout } from '../../layouts'
import { ContentBox, BackListButton, SaveButton, ResetButton } from '../../partials'
import { FormTypes } from '../../../types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { IVehicleParams } from '../../../store/types'
import { IFormRef } from '../../../types'
import { getFormattedValidationErrors } from '../../../utils/mixins'
import Form from './Form'
import { fetchCreateVehicle, resetCreateVehicle } from '../../../store/features/vehicles/createVehicleSlice'

const Create = () => {
  const { t } = useTranslation()
  const formRef = useRef<IFormRef>(null)
  const dispatch = useAppDispatch()

  const { isLoading, response, error } = useAppSelector(state => state.createVehicle)

  useEffect(() => {
    if (response !== null) {
      showNotification({
        color: 'green',
        title: t('successful'),
        message: t('created')
      })

      dispatch(resetCreateVehicle())
    }
  }, [response, t, dispatch])

  useEffect(() => {
    if (error !== null) {
      if (error.response.status === 422) {
        formRef.current!.setErrors(getFormattedValidationErrors(error))
      } else {
        showNotification({
          color: 'red',
          title: t('unsuccessful'),
          message: error.response.data ? error.response.data.message : t('errors.unknown')
        })
      }
    }
  }, [error, t])

  useEffect(() => {
    if (response !== null) {
      dispatch(resetCreateVehicle())
      formRef.current!.reset()
    }
  }, [response, dispatch])

  const handleSubmit = async (data: IVehicleParams) => {
    console.log(data)
    await dispatch(fetchCreateVehicle(data))
  }

  return (
    <MainLayout>
      <LoadingOverlay visible={isLoading} />
      <ContentBox title={t('content_actions.create')}>
        <Form
          id="create-vehicle-form"
          type={FormTypes.CREATE}
          ref={formRef}
          initialValues={{
            user: '',
            company: '',
            location: '',
            vin: '',
            unit: '',
            brand_name: '',
            model_name: '',
            model_detail_name: '',
            mileage: 0,
            company_group: '',
            company_class: '',
            model_year: null,
            color: '',
            condition: '',
            in_service_date: '',
            tags: []
          }}
          onSubmit={handleSubmit}
        />
      </ContentBox>
      <ContentBox>
        <Grid>
          <Grid.Col span={6}>
            <BackListButton to="/vehicles" />
          </Grid.Col>
          <Grid.Col span={6}>
            <Group position="right">
              <SaveButton form="create-vehicle-form" />
              <ResetButton form="create-vehicle-form" />
            </Group>
          </Grid.Col>
        </Grid>
      </ContentBox>
    </MainLayout>
  )
}

export default Create
